import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { directivesModule } from 'src/app/directives/directives.module';
import { PipesModule } from 'src/app/pipes/pipes.module';

import { FooterModule } from '../../footer/footer.module';
import { JackpotCounterModule } from '../../jackpot-notification/jackpot-counter.module';
import { MobileModule } from '../../mobile/mobile.module';
import { LobbyVerticalsModule } from '../keywords-casino/lobby-verticals.module';

import { GalleryCasinoComponent } from './gallery-casino.component';

@NgModule({
  declarations: [GalleryCasinoComponent],
  imports: [
    CommonModule,
    IonicModule,
    PipesModule,
    FooterModule,
    LobbyVerticalsModule,
    JackpotCounterModule,
    MobileModule,
    directivesModule,
  ],
  exports: [GalleryCasinoComponent]
})
export class GalleryCasinoModule { }
